import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useE844sdFieldSchema() {
  return useQuery({
    ...orpc.shipAndDebit.e844sdFieldSchema.getSchema.queryOptions({
      input: {},
    }),
    staleTime: Infinity,
  });
}
